import { createStyles, makeStyles } from '@mui/styles';

// стили для глобальных элементов страницы
const useStyles = makeStyles(() => createStyles({
  '@global': {
    div: {
      boxSizing: 'border-box',
      margin: 0,
      padding: 0,
    },
    html: {
      '-webkit-font-smoothing': 'antialiased',
      '-moz-osx-font-smoothing': 'grayscale',
      '--color-tooltip': 'gray',
      height: '100%',
      width: '100%'
    },
    body: {
      height: '100%',
      width: '100%',
      padding: 0,
      margin: 0,
    },
    a: {
      textDecoration: 'none'
    },
    '#root': {
      height: '100%',
      width: '100%',
      fontFamily:'primary',
    }
  }
}));

const GlobalStyles = () => {
  useStyles();

  return null;
};

export default GlobalStyles;
